/**
 * Branding in one place. The product name is a working name (PRD Q2 open); when it is
 * decided, change this file (and public/icons, manifest.webmanifest, index.html meta —
 * see docs/DESIGN.md "Rebranding"). Nothing else in the app hard-codes the name.
 * The organisation's own name and logo come from the session (each client is a tenant).
 */
export const BRAND = {
  /** Product name shown in the sidebar, sign-in and title bar. */
  product: 'QXM',
  /** Short form for tight spots (installed app name, collapsed sidebar). */
  short: 'QXM',
  /** One line under the wordmark on the sign-in screen. */
  tagline: 'Controlled documents, found in seconds',
  /**
   * Sign-in landing headline (boss TG 1344, 25 Oct 2026: education customers). Wording rule: "supports … requirements",
   * never "certified" / "compliant". Empty title = the plain sign-in card without the hero.
   */
  landing: {
    /** Landing brand (boss TG 1355/1356): Veltrion is the app name on the landing page; no "QXM" there until production. */
    appName: 'Veltrion',
    logoLight: '/brand/veltrion_logo_light.webp',
    logoDark: '/brand/veltrion_logo_dark.webp',
    /** Partner company (boss TG 1355). Logo redrawn in high resolution from the boss's JPEG: ~/templates/brand/agf. */
    partnerName: 'AGF',
    partnerLogo: '/brand/agf_logo.webp',
    poweredBy: 'ITCORE SOLUTIONS INC.',
    eyebrow: 'ISO 21001:2025',
    title: 'Educational Organizations Management System',
    subtitle: 'Documented Information Control',
    body: 'Veltrion supports ISO 21001:2025 and ISO 9001:2026 requirements for documented information: approvals, revisions, records and audit evidence in one place.',
    heroUrl: '/hero-edu.webp',
  },
  /** Optional product logo (served from /public). Empty = the catalogue-drawer wordmark. */
  logoUrl: '' as string,
  /** Who runs the service, for the footer and Help. */
  operator: 'ITCORE Solutions Inc.',
  supportEmail: 'support@itcore-apps.com',
  /** Browser tab title suffix: "Search – QXM". */
  titleSuffix: 'QXM',
} as const;

export const pageTitle = (title?: string): string => (title ? `${title} – ${BRAND.titleSuffix}` : BRAND.titleSuffix);
